export const CLUSTERS_DRAWER_FILTER_KEYS = [
  'project',
  'agentStatus',
  'managed',
] as const;

const isActiveFilterValue = (value: unknown) => {
  if (value == null) {
    return false;
  }

  if (Array.isArray(value)) {
    return value.length > 0;
  }

  return true;
};

export const getDrawerFilterCount = (
  values: Record<string, unknown> = {}
): number =>
  CLUSTERS_DRAWER_FILTER_KEYS.reduce((count, key) => {
    if (isActiveFilterValue(values[key])) {
      return count + 1;
    }

    return count;
  }, 0);
